import { render } from "./RatingStats.vue?vue&type=template&id=71c8ebe6&scoped=true&ts=true"
import script from "./RatingStats.vue?vue&type=script&lang=ts"
export * from "./RatingStats.vue?vue&type=script&lang=ts"

import "./RatingStats.vue?vue&type=style&index=0&id=71c8ebe6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c8ebe6"]])

export default __exports__